import api from '../../../services/Api';
import { IAuditoriaProvisaoIcmsResultado } from '../interfaces/IAuditoriaProvisaoIcms';

export const AuditoriaProvisaoIcmsService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaProvisaoIcmsResultado> {
    const response = await api.get<IAuditoriaProvisaoIcmsResultado>('auditoria-provisao-icms/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoFiscal: '',
        fundamentacaoContabil: '',
        anomaliasDetectadas: [],
        mesesConciliados: [],
      }
    );
  },
};
